import { render, staticRenderFns } from "./open-pay.vue?vue&type=template&id=5d58df04&scoped=true&"
import script from "./open-pay.vue?vue&type=script&lang=js&"
export * from "./open-pay.vue?vue&type=script&lang=js&"
import style0 from "./open.scss?vue&type=style&index=0&id=5d58df04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58df04",
  null
  
)

export default component.exports